import { render, staticRenderFns } from "./SettingPayment.vue?vue&type=template&id=54291d97"
import script from "./SettingPayment.vue?vue&type=script&lang=js"
export * from "./SettingPayment.vue?vue&type=script&lang=js"
import style0 from "./SettingPayment.vue?vue&type=style&index=0&id=54291d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports